import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    deleteCookie('sessionid');
    try{
      deleteCookie('csrftoken');
    } catch (error) {
      console.log(error);
    }
    

    navigate('/login');
  }, [navigate]);

  return null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export default Logout;